import { render } from "./select-material.vue?vue&type=template&id=b063c05c"
import script from "./select-material.vue?vue&type=script&lang=js"
export * from "./select-material.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__